import axios from 'axios';
import { OtpCodeModel, ValidateOtpCodeModel } from '../types';
import './axios-interceptor';

export default {
  async getOtp(otp: OtpCodeModel) {
    return await axios.post(`user/otp`, otp);
  },

  async validateOtp(otp: ValidateOtpCodeModel) {
    return await axios.post(`user/validateOtp`, otp);
  },
};
